'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _joi = require('../../services/joi');

var _joi2 = _interopRequireDefault(_joi);

var _DynamicFormContainer = require('./DynamicFormContainer');

var _DynamicFormContainer2 = _interopRequireDefault(_DynamicFormContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createForm = function createForm(_ref) {
  var children = _ref.children,
      fields = _ref.fields,
      derivedFields = _ref.derivedFields,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['children', 'fields', 'derivedFields', 'onSubmit', 'onChange']);

  var validationRules = _joi2.default.object(fields.filter(function (field) {
    return field.validation;
  }).reduce(function (out, field) {
    return _extends({}, out, _defineProperty({}, field.id, field.validation.label(field.label || field.id)));
  }, {}));

  return _react2.default.createElement(
    _DynamicFormContainer2.default,
    _extends({
      onSubmit: onSubmit || _lodash.noop,
      validationRules: validationRules,
      fields: fields,
      derivedFields: derivedFields,
      onChange: onChange || _lodash.noop
    }, props),
    children
  );
};

createForm.propTypes = {
  children: _propTypes2.default.node.isRequired,
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  derivedFields: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = createForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/createForm.js
// module id = 456
// module chunks = 0